// extracted by mini-css-extract-plugin
module.exports = {"article-head":"article-head__2V6Jp","articleHead":"article-head__2V6Jp","title":"title__ChI9S","image":"image__fxVe5","content":"content__U7tyl"};